import React from "react";

// Smartphone con l'app pubblica reale dentro (iframe 390×844 ridimensionato): sempre aggiornato, nessuno screenshot da mantenere
export function PhoneFrame({ src, scale = 0.6, label, testid, className = "", delay = 0 }) {
  const w = 390, h = 844;
  return (
    <figure className={`flex flex-col items-center gap-3 animate-fade-up ${className}`} style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
      <div className="relative rounded-[2.6rem] bg-zinc-900 p-[9px] shadow-2xl ring-1 ring-black/40" style={{ width: w * scale + 18, height: h * scale + 18 }}>
        <div className="absolute left-1/2 -translate-x-1/2 top-[9px] h-[18px] w-[90px] rounded-b-2xl bg-zinc-900 z-10" />
        <div className="relative h-full w-full overflow-hidden rounded-[2rem] bg-white" ref={(el) => { if (el) { el.scrollTop = 0; el.scrollLeft = 0; } }}>
          <iframe title={label || "Anteprima app"} src={src} loading="lazy" tabIndex={-1} aria-hidden="true" scrolling="no"
                  onLoad={(e) => { const p = e.currentTarget.parentElement; if (p) { p.scrollTop = 0; p.scrollLeft = 0; } }}
                  className="absolute top-0 left-0 origin-top-left pointer-events-none select-none border-0"
                  style={{ width: w, height: h, transform: `scale(${scale})` }} />
        </div>
      </div>
      {label && <figcaption className="text-sm font-semibold text-slate-700 text-center">{label}</figcaption>}
    </figure>
  );
}
